import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { NAV_ITEMS, NavItem } from '../../shared/nav-items';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { UserProfileService } from '../../services/user-profile.service';
import { FormsModule } from '@angular/forms';
import { CountrySelectionService } from '../../services/country-selection.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [RouterLink, RouterLinkActive, CommonModule, FormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {
  navItems: NavItem[] = NAV_ITEMS;
  topLevelNavItems: NavItem[] = []; // New property for filtered top-level items
  currentUserRole: string = '';
  selectedCountry: any;
  countries: any[] = [];
  isMenuOpen = false;

  constructor(
    private authService: AuthService,
    private userProfileService: UserProfileService,
    private countrySelectionService: CountrySelectionService
  ) { }

  ngOnInit(): void {
    this.currentUserRole = this.authService.getUserRole();
    this.countries = this.countrySelectionService.getCountries();
    this.countrySelectionService.selectedCountry$.subscribe(country => {
      this.selectedCountry = country;
    });

    // Filter NAV_ITEMS for top-level display
    const topLevelLabels = [
      'Home',
      'My Knowledge',
      'My Health',
      'Find A Service',
      'Your Tips',
      'My Favourites'
    ];
    this.topLevelNavItems = this.navItems
      .filter(item => topLevelLabels.includes(item.label))
      .map(item => ({ ...item, children: undefined }));
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  onCountryChange(): void {
    this.countrySelectionService.setSelectedCountry(this.selectedCountry);
  }

  shouldShowMenuItem(item: NavItem): boolean {
    if (!item.roles) {
      return true; // Show if no specific roles are defined
    }
    return item.roles.includes(this.currentUserRole);
  }
}


